import {useBssPopupsQuery} from '@/framework/gql/popup.graphql';

export function useEntrancePopup() {
    const {data, loading: isLoading, error} = useBssPopupsQuery();
    return {
        data: data?.bssPopups?.items,
        isLoading: isLoading,
        error: error,
    };
}
